"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.SLC_CLASSIC_SETTINGS_AGREEMENT_TYPES = exports.SLC_CLASSIC_ONBOARDING_AGREEMENT_TYPES = exports.SLC_FULLY_SECURED_SETTINGS_AGREEMENT_TYPES = exports.SLC_PRICING_SETTINGS_AGREEMENT_TYPES = exports.SLC_SETTINGS_AGREEMENT_TYPES = exports.SETTINGS_AGREEMENT_TYPES = exports.ONBOARDING_SKIP_AUTOPILOT_AGREEMENT_TYPES = exports.SLC_FULLY_SECURED_ONBOARDING_AGREEMENT_TYPES = exports.SLC_PRICING_ONBOARDING_AGREEMENT_TYPES = exports.SLC_ONBOARDING_AGREEMENT_TYPES = exports.ONBOARDING_AGREEMENT_TYPES = exports.WALLET_AGREEMENT_TYPES = exports.AcceptancePolicyType = exports.AgreementSourceType = exports.AgreementType = void 0;
var AgreementType;
(function (AgreementType) {
    AgreementType["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
    AgreementType["PRIVACY_POLICY"] = "PRIVACY_POLICY";
    AgreementType["ESIGN_CONSENT_AGREEMENT"] = "ESIGN_CONSENT_AGREEMENT";
    AgreementType["CREDIT_LINE_AGREEMENT"] = "CREDIT_LINE_AGREEMENT";
    AgreementType["BRB_CREDIT_LINE_AGREEMENT"] = "BRB_CREDIT_LINE_AGREEMENT";
    AgreementType["LEAD_CREDIT_LINE_AGREEMENT"] = "LEAD_CREDIT_LINE_AGREEMENT";
    AgreementType["TRUTH_IN_LENDING_DISCLOSURE"] = "TRUTH_IN_LENDING_DISCLOSURE";
    AgreementType["BRB_TRUTH_IN_LENDING_DISCLOSURE"] = "BRB_TRUTH_IN_LENDING_DISCLOSURE";
    AgreementType["LEAD_TRUTH_IN_LENDING_DISCLOSURE"] = "LEAD_TRUTH_IN_LENDING_DISCLOSURE";
    AgreementType["AUTOPAY_AUTHORIZATION"] = "AUTOPAY_AUTHORIZATION";
    AgreementType["STRIPE_CONNECT_AGREEMENT"] = "STRIPE_CONNECT_AGREEMENT";
    AgreementType["DDA_AGREEMENT"] = "DDA_AGREEMENT";
    AgreementType["BRB_DDA_AGREEMENT"] = "BRB_DDA_AGREEMENT";
    AgreementType["LEAD_DDA_AGREEMENT"] = "LEAD_DDA_AGREEMENT";
    AgreementType["SECURED_CREDIT_LINE_AGREEMENT"] = "SECURED_CREDIT_LINE_AGREEMENT";
    AgreementType["SECURED_TERMS_AND_CONDITIONS"] = "SECURED_TERMS_AND_CONDITIONS";
    AgreementType["SECURED_TRUTH_IN_LENDING_DISCLOSURE"] = "SECURED_TRUTH_IN_LENDING_DISCLOSURE";
    AgreementType["SECURED_AUTOPAY_AUTHORIZATION"] = "SECURED_AUTOPAY_AUTHORIZATION";
    AgreementType["PRICING_SECURED_TERMS_AND_CONDITIONS"] = "PRICING_SECURED_TERMS_AND_CONDITIONS";
    AgreementType["PRICING_SECURED_AUTOPAY_AUTHORIZATION"] = "PRICING_SECURED_AUTOPAY_AUTHORIZATION";
    AgreementType["PRICING_SECURED_CREDIT_LINE_AGREEMENT"] = "PRICING_SECURED_CREDIT_LINE_AGREEMENT";
    AgreementType["PRICING_SECURED_TRUTH_IN_LENDING_DISCLOSURE"] = "PRICING_SECURED_TRUTH_IN_LENDING_DISCLOSURE";
    AgreementType["FULLY_SECURED_TERMS_AND_CONDITIONS"] = "FULLY_SECURED_TERMS_AND_CONDITIONS";
    AgreementType["FULLY_SECURED_AUTOPAY_AUTHORIZATION"] = "FULLY_SECURED_AUTOPAY_AUTHORIZATION";
    AgreementType["FULLY_SECURED_CREDIT_LINE_AGREEMENT"] = "FULLY_SECURED_CREDIT_LINE_AGREEMENT";
    AgreementType["FULLY_SECURED_TRUTH_IN_LENDING_DISCLOSURE"] = "FULLY_SECURED_TRUTH_IN_LENDING_DISCLOSURE";
    AgreementType["SLC_AUTOPAY_AUTHORIZATION"] = "SLC_AUTOPAY_AUTHORIZATION";
    AgreementType["SLC_CREDIT_LINE_AGREEMENT"] = "SLC_CREDIT_LINE_AGREEMENT";
    AgreementType["SLC_TRUTH_IN_LENDING_DISCLOSURE"] = "SLC_TRUTH_IN_LENDING_DISCLOSURE";
    AgreementType["SLC_TERMS_AND_CONDITIONS"] = "SLC_TERMS_AND_CONDITIONS";
})(AgreementType = exports.AgreementType || (exports.AgreementType = {}));
var AgreementSourceType;
(function (AgreementSourceType) {
    AgreementSourceType["MARKDOWN"] = "MARKDOWN";
    AgreementSourceType["WEBSITE"] = "WEBSITE";
})(AgreementSourceType = exports.AgreementSourceType || (exports.AgreementSourceType = {}));
var AcceptancePolicyType;
(function (AcceptancePolicyType) {
    AcceptancePolicyType["NONE"] = "NONE";
    AcceptancePolicyType["APP_OPEN_BLOCKING"] = "APP_OPEN_BLOCKING";
    AcceptancePolicyType["APP_OPEN_NON_BLOCKING"] = "APP_OPEN_NON_BLOCKING";
})(AcceptancePolicyType = exports.AcceptancePolicyType || (exports.AcceptancePolicyType = {}));
exports.WALLET_AGREEMENT_TYPES = [AgreementType.STRIPE_CONNECT_AGREEMENT, AgreementType.DDA_AGREEMENT];
exports.ONBOARDING_AGREEMENT_TYPES = __spreadArray([
    AgreementType.CREDIT_LINE_AGREEMENT,
    AgreementType.TRUTH_IN_LENDING_DISCLOSURE,
    AgreementType.AUTOPAY_AUTHORIZATION
], exports.WALLET_AGREEMENT_TYPES, true);
exports.SLC_ONBOARDING_AGREEMENT_TYPES = __spreadArray([
    AgreementType.SECURED_CREDIT_LINE_AGREEMENT,
    AgreementType.SECURED_TERMS_AND_CONDITIONS,
    AgreementType.SECURED_TRUTH_IN_LENDING_DISCLOSURE,
    AgreementType.SECURED_AUTOPAY_AUTHORIZATION
], exports.WALLET_AGREEMENT_TYPES, true);
exports.SLC_PRICING_ONBOARDING_AGREEMENT_TYPES = __spreadArray([
    AgreementType.PRICING_SECURED_CREDIT_LINE_AGREEMENT,
    AgreementType.PRICING_SECURED_TERMS_AND_CONDITIONS,
    AgreementType.PRICING_SECURED_TRUTH_IN_LENDING_DISCLOSURE,
    AgreementType.PRICING_SECURED_AUTOPAY_AUTHORIZATION
], exports.WALLET_AGREEMENT_TYPES, true);
exports.SLC_FULLY_SECURED_ONBOARDING_AGREEMENT_TYPES = __spreadArray([
    AgreementType.FULLY_SECURED_CREDIT_LINE_AGREEMENT,
    AgreementType.FULLY_SECURED_TERMS_AND_CONDITIONS,
    AgreementType.FULLY_SECURED_TRUTH_IN_LENDING_DISCLOSURE,
    AgreementType.FULLY_SECURED_AUTOPAY_AUTHORIZATION
], exports.WALLET_AGREEMENT_TYPES, true);
exports.ONBOARDING_SKIP_AUTOPILOT_AGREEMENT_TYPES = __spreadArray([
    AgreementType.CREDIT_LINE_AGREEMENT,
    AgreementType.TRUTH_IN_LENDING_DISCLOSURE,
    AgreementType.AUTOPAY_AUTHORIZATION
], exports.WALLET_AGREEMENT_TYPES, true);
exports.SETTINGS_AGREEMENT_TYPES = __spreadArray([
    AgreementType.CREDIT_LINE_AGREEMENT,
    AgreementType.TRUTH_IN_LENDING_DISCLOSURE,
    AgreementType.TERMS_AND_CONDITIONS,
    AgreementType.AUTOPAY_AUTHORIZATION,
    AgreementType.ESIGN_CONSENT_AGREEMENT
], exports.WALLET_AGREEMENT_TYPES, true);
exports.SLC_SETTINGS_AGREEMENT_TYPES = __spreadArray([
    AgreementType.SECURED_CREDIT_LINE_AGREEMENT,
    AgreementType.SECURED_TERMS_AND_CONDITIONS,
    AgreementType.SECURED_TRUTH_IN_LENDING_DISCLOSURE,
    AgreementType.SECURED_AUTOPAY_AUTHORIZATION,
    AgreementType.ESIGN_CONSENT_AGREEMENT
], exports.WALLET_AGREEMENT_TYPES, true);
exports.SLC_PRICING_SETTINGS_AGREEMENT_TYPES = __spreadArray([
    AgreementType.PRICING_SECURED_CREDIT_LINE_AGREEMENT,
    AgreementType.PRICING_SECURED_TERMS_AND_CONDITIONS,
    AgreementType.PRICING_SECURED_TRUTH_IN_LENDING_DISCLOSURE,
    AgreementType.PRICING_SECURED_AUTOPAY_AUTHORIZATION,
    AgreementType.ESIGN_CONSENT_AGREEMENT
], exports.WALLET_AGREEMENT_TYPES, true);
exports.SLC_FULLY_SECURED_SETTINGS_AGREEMENT_TYPES = __spreadArray([
    AgreementType.FULLY_SECURED_CREDIT_LINE_AGREEMENT,
    AgreementType.FULLY_SECURED_TERMS_AND_CONDITIONS,
    AgreementType.FULLY_SECURED_TRUTH_IN_LENDING_DISCLOSURE,
    AgreementType.FULLY_SECURED_AUTOPAY_AUTHORIZATION,
    AgreementType.ESIGN_CONSENT_AGREEMENT
], exports.WALLET_AGREEMENT_TYPES, true);
exports.SLC_CLASSIC_ONBOARDING_AGREEMENT_TYPES = __spreadArray([
    AgreementType.SLC_AUTOPAY_AUTHORIZATION,
    AgreementType.SLC_CREDIT_LINE_AGREEMENT,
    AgreementType.SLC_TRUTH_IN_LENDING_DISCLOSURE,
    AgreementType.SLC_TERMS_AND_CONDITIONS
], exports.WALLET_AGREEMENT_TYPES, true);
exports.SLC_CLASSIC_SETTINGS_AGREEMENT_TYPES = __spreadArray([
    AgreementType.SLC_AUTOPAY_AUTHORIZATION,
    AgreementType.SLC_CREDIT_LINE_AGREEMENT,
    AgreementType.SLC_TRUTH_IN_LENDING_DISCLOSURE,
    AgreementType.SLC_TERMS_AND_CONDITIONS,
    AgreementType.ESIGN_CONSENT_AGREEMENT
], exports.WALLET_AGREEMENT_TYPES, true);
